import React, { useState } from 'react'
import PolaroidModal from '../../../../components/polaroid-modal/polaroid-modal'
import heroImage from '../../../../assets/images/optimized/r-outside.webp';

import './about-us.css'

const AboutUs = () => {
  const [currentImage, setCurrentImage] = useState(null);

  const handleImageClick = () => {
    setCurrentImage(heroImage);
  };

  const handleClose = () => {
    setCurrentImage(null);
  };

  return (
    <section className="home__about_us">
      <h2 className="home__about_us__title">Din hemvist i hjärtat av Visby</h2>
      <div className="home__about_us__content">
        {/* <h3>Vår vision</h3> */}
        <p>
          Här, centralt beläget i Visbys livliga innerstad, är du omgiven av en unik kombination av frodig natur och en fascinerande medeltida historia.
          Visby, känd för sin välbevarade ringmur och medeltida kyrkoruinerna, är en plats där historien lever och andas i varje kullerstensgata och gränd.
          Oavsett om du vill uppleva stadens liv och rörelse eller utforska det enastående landskapet som omger oss,
          erbjuder vårt läge oöverträffad tillgång till allt det bästa som Visby och Gotland har att erbjuda.
        </p>
      </div>
      <div className="home__about_us__image">
        <button
          aria-label="Välkommen till Ringarens Hotell i Visby"
          className="about_us__polaroid"
          onClick={handleImageClick}
        >
          <div className="about_us__polaroid__image">
            <img src={heroImage} alt="Välkommen till Ringarens Hotell i Visby" />
          </div>
        </button>
      </div>

      <PolaroidModal
        open={currentImage !== null}
        onClose={handleClose}
        image={currentImage}
        caption={"Välkommen till Ringarens Hotell i Visby"}
      />
    </section>
  )
}

export default AboutUs